export const countryList: Record<
  string,
  (
    | 'bn'
    | 'cz'
    | 'de'
    | 'dk'
    | 'en'
    | 'es'
    | 'fi'
    | 'fr'
    | 'hi'
    | 'hu'
    | 'it'
    | 'nl'
    | 'no'
    | 'pl'
    | 'pt'
    | 'ru'
    | 'se'
    | 'si'
    | 'sk'
  )[]
> = {
  AD: ['en', 'fr', 'es'],
  AF: ['en'],
  AL: ['en'],
  AO: ['en', 'pt'],
  AR: ['en', 'es'],
  AT: ['en', 'de'],
  AU: ['en'],
  AZ: ['en', 'ru'],
  BA: ['en'],
  BD: ['en', 'bn'],
  BE: ['en', 'fr', 'nl', 'de'],
  BG: ['en', 'ru'],
  BH: ['en'],
  BI: ['en', 'fr'],
  BJ: ['en', 'fr'],
  BN: ['en'],
  BO: ['en', 'es'],
  BR: ['en', 'pt'],
  BW: ['en'],
  BY: ['en', 'ru'],
  CA: ['en', 'fr'],
  CH: ['en', 'de', 'fr', 'it'],
  CI: ['fr'],
  CL: ['en', 'es'],
  CM: ['en', 'fr'],
  CN: ['en'],
  CO: ['en', 'es'],
  CR: ['en', 'es'],
  CU: ['en', 'es'],
  CY: ['en'],
  CZ: ['en', 'cz'],
  DE: ['en', 'de'],
  DK: ['en', 'dk'],
  DO: ['en', 'es'],
  EC: ['en', 'es'],
  EE: ['en', 'ru'],
  EG: ['en'],
  ES: ['en', 'es'],
  FI: ['en', 'fi', 'se'],
  FR: ['en', 'fr'],
  GB: ['en'],
  GE: ['en', 'ru'],
  GR: ['en'],
  GT: ['en', 'es'],
  HK: ['en'],
  HN: ['en', 'es'],
  HR: ['en'],
  HU: ['en', 'hu'],
  ID: ['en'],
  IE: ['en'],
  IL: ['en', 'ru'],
  IN: ['en', 'hi', 'bn'],
  IQ: ['en'],
  IR: ['en'],
  IS: ['en'],
  IT: ['en', 'it'],
  JM: ['en'],
  JP: ['en'],
  KE: ['en'],
  KG: ['en', 'ru'],
  KH: ['en'],
  KR: ['en'],
  KZ: ['en', 'ru'],
  LB: ['en', 'fr'],
  LK: ['en'],
  LT: ['en'],
  LU: ['en', 'fr', 'de'],
  LV: ['en', 'ru'],
  MA: ['en', 'fr'],
  MG: ['en', 'fr'],
  MK: ['en'],
  MX: ['en', 'es'],
  MY: ['en'],
  NG: ['en'],
  NL: ['en', 'nl'],
  NO: ['en', 'no'],
  NP: ['en'],
  NZ: ['en'],
  OM: ['en'],
  PA: ['en', 'es'],
  PE: ['en', 'es'],
  PH: ['en'],
  PK: ['en'],
  PL: ['en', 'pl'],
  PT: ['en', 'pt'],
  PY: ['en', 'es'],
  QA: ['en'],
  RO: ['en'],
  RU: ['en', 'ru'],
  SA: ['en'],
  SE: ['en', 'se'],
  SG: ['en'],
  SI: ['en', 'si'],
  SK: ['en', 'sk'],
  SN: ['en', 'fr'],
  SR: ['en', 'nl'],
  SZ: ['en'],
  TH: ['en'],
  TJ: ['en', 'ru'],
  TM: ['en', 'ru'],
  TR: ['en'],
  UA: ['en', 'ru'],
  US: ['en'],
  UY: ['en', 'es'],
  UZ: ['en', 'ru'],
  VE: ['en', 'es'],
  VN: ['en'],
  ZA: ['en'],
  ZW: ['en'],
}
